<div class="w-full h-96"></div>
<div class="flex justify-center items-center bg-black bg-opacity-60 absolute top-0 left-0 right-0 bottom-0">
  <div class="modal-container">
    <div class="flex justify-end">
      <span class="cursor-pointer" (click)="clickedClose.emit()">
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
          <g fill="none" fill-rule="evenodd">
            <g fill="#999">
              <g>
                <g>
                  <path
                    d="M19.495 5.417c.288 0 .565.115.768.32.42.422.42 1.104 0 1.527l-5.731 5.733 5.731 5.735c.205.203.32.48.32.768 0 .29-.115.566-.32.77-.204.202-.48.315-.768.313-.288.002-.565-.111-.769-.314l-5.731-5.734-5.721 5.723c-.203.207-.48.324-.769.325-.287.002-.564-.111-.768-.314-.205-.203-.32-.48-.32-.769 0-.288.115-.565.32-.768l5.726-5.73-5.726-5.727c-.425-.425-.425-1.113 0-1.538.424-.425 1.112-.425 1.537 0L13 11.465l5.726-5.728c.203-.205.48-.32.769-.32z"
                    transform="translate(-797 -234) translate(409 222) translate(388 12)" />
                </g>
              </g>
            </g>
          </g>
        </svg>
      </span>
    </div>
    <div class="flex justify-center">
      <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="D010_100_405" transform="translate(-677.000000, -114.000000)" fill="#444444">
            <g id="Icon" transform="translate(677.333333, 114.333333)">
              <path
                d="M26.6666667,-1.42108547e-14 C41.3710939,-1.42108547e-14 53.3333333,11.9622395 53.3333333,26.6666667 C53.3333333,41.3710939 41.3710939,53.3333333 26.6666667,53.3333333 C11.9622395,53.3333333 0,41.3710939 0,26.6666667 C0,11.9622395 11.9622395,-1.42108547e-14 26.6666667,-1.42108547e-14 Z M26.6666667,2.66666667 C13.4335939,2.66666667 2.66666667,13.4335939 2.66666667,26.6666667 C2.66666667,39.8997395 13.4335939,50.6666667 26.6666667,50.6666667 C39.8997395,50.6666667 50.6666667,39.8997395 50.6666667,26.6666667 C50.6666667,13.4335939 39.8997395,2.66666667 26.6666667,2.66666667 Z M26.6666667,37.3333333 C27.4036459,37.3333333 28,37.9296875 28,38.6666667 L28,41.3333333 C28,42.0703125 27.4036459,42.6666667 26.6666667,42.6666667 C25.9296875,42.6666667 25.3333333,42.0703125 25.3333333,41.3333333 L25.3333333,38.6666667 C25.3333333,37.9296875 25.9296875,37.3333333 26.6666667,37.3333333 Z M26.6666667,10.6666667 C27.4036459,10.6666667 28,11.2630208 28,12 L28,33.3333333 C28,34.0703125 27.4036459,34.6666667 26.6666667,34.6666667 C25.9296875,34.6666667 25.3333333,34.0703125 25.3333333,33.3333333 L25.3333333,12 C25.3333333,11.2630208 25.9296875,10.6666667 26.6666667,10.6666667 Z"
                id="Combined-Shape"></path>
            </g>
          </g>
        </g>
      </svg>
    </div>
    <div class="row justify-content-center mb-4 mt-3">
      <h1 class="col-12 text-center">
        <strong>{{ 'POPUPS_BLOCKED_MODAL.TITLE' | translate }}</strong>
      </h1>
    </div>
    <div class="text-center mb-5">
      {{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.1' | translate }}<br>
      <strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.2' | translate}}</strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.3' | translate }}
    </div>
    <div class="flex items-center mb-4 mx-2">
      <img src="assets/icons/chrome.png" class="mr-2 w-8 h-8">
      <span><strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.CHROME_OPERA.1' | translate }}</strong>&nbsp;{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.CHROME_OPERA.2' | translate }}</span>
    </div>
    <div class="flex items-center mb-4 mx-2">
      <img src="assets/icons/firefox.png" class="mr-2 w-8 h-8">
      <span><strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.FIREFOX.1' | translate }}</strong>&nbsp;{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.FIREFOX.2' | translate }}</span>
    </div>
    <div class="flex items-center mb-4 mx-2">
      <img src="assets/icons/safari.png" class="mr-2 w-8 h-8">
      <span><strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.SAFARI.1' | translate }}</strong>&nbsp;{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.SAFARI.2' | translate }}</span>
    </div>
    <div class="flex items-center mb-4 mx-2">
      <img src="assets/icons/edge.png" class="mr-2 w-8 h-8">
      <span><strong>{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.EDGE.1' | translate }}</strong>&nbsp;{{ 'POPUPS_BLOCKED_MODAL.DESCRIPTION.EDGE.2' | translate }}</span>
    </div>
    <div class="flex items-center justify-center mt-8">
      <button type="button" id="understand" class="btn-san-primary"
        (click)="clickedClose.emit()">{{ 'POPUPS_BLOCKED_MODAL.BUTTON' | translate }}</button>
    </div>
  </div>
</div>